"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modifierToUpperCase = void 0;
var isTypeString_1 = require("../../typeGuards/isTypeString");
var modifierToUpperCase = function (value) {
    if (!isTypeString_1.isTypeString(value)) {
        console.log("UseForm: value must be a string to be modified by modifierToUpperCase");
        return value;
    }
    return value.toUpperCase();
};
exports.modifierToUpperCase = modifierToUpperCase;
//# sourceMappingURL=modifierToUpperCase.js.map